export function openMailTo(mailTo: string) {
  window.open(mailTo, "_parent");
}

export function openNewBackgroundTab(url: string) {
  window.open(url, "_blank");
}
